import { render } from "./BundlingChildProduct.vue?vue&type=template&id=768c205c"
import script from "./BundlingChildProduct.vue?vue&type=script&lang=js"
export * from "./BundlingChildProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__